import React, { useRef, useEffect, useState } from "react";
import { Formik, Field, isEmptyArray } from "formik";
import Form, { InputSection } from "../components/Form";
import { DropDown } from "../../../ui/DropDown";
import Input from "../../../ui/Input";
import { parseDropdown } from "../../../utils/parseDropdown";
import { postEndpoint, putEndpoint ,GetHook} from "../../../api/api";
import { get } from "../../../utils/get";
import { SETTINGS_URL , MATRIX_URL} from "../../../api/urls";
import { TitleText } from "../../../ui/Text";
import { CloseIcon2 } from "../../../assets/svg/CloseIcon2";
import styled from "styled-components";
import Modal from "../../../ui/Modal";
import { ScorecardIcon } from "../../../assets/svg/ScorecardIcon";
import { OrganisationTypeIcon } from "../../../assets/svg/OrganisationTypeIcon";
import { SettingsIcon } from "../../../assets/svg/SettingsIcon";
import { Button } from "../../../ui/Button";
import { toast } from "react-toastify";
import { GlobalSettingsSchema } from "../../../utils/validationSchema/GlobalSettingsSchema";
import { KPIGlobalSettings } from "./KPIGlobalSettings";

interface IProps {
  closeModal?: any;
  setHandleSubmit?: any;
  setScorecards?: any;
  periods?: any;
  editData?: any;
  edit?: any;
  isModalOpen?: any;
  step?: any;
  setStep?: any;
}

const SettingsForm = ({
  closeModal,
  setHandleSubmit,
  setScorecards,
  periods,
  isModalOpen,
  editData,
  edit,
  step,
  setStep,
}: IProps) => {
  const [scoringMatrix, setScoringMatrix] = useState<any>([]);
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  const formRef: any = useRef<any>(null);
  const { data: matrixs } = GetHook(MATRIX_URL);

  const { id } = editData;

  const isAddMode = !id;

  const handleSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  useEffect(() => {
    setHandleSubmit(() => handleSubmit);
    return () => {};
  }, []);

  const toggleModal = () => {
    setScoringMatrix([]);
    formRef.current.resetForm({ values: "" });
    closeModal();
  };

  const AddSettings = (values, { resetForm }) => {
    const payload = {
      scoring_matrix_id: get(values, "scoring_matrix.value"),
      name: get(values, "name"),
      period_id: get(values, "period_id.value"),
      max_score: get(values, "max_score"),
      min_score: get(values, "min_score"),
      target_score: get(values, "target_score"),
      score_matrix: scoringMatrix,
      respondents: get(values, "respondents"),
      review_cycle: get(values, "review_cycle.value"),
      review_start_days: get(values, "review_start_days"),
    };
    createReq(SETTINGS_URL, payload);
    resetForm({ values: "" });
  };

  const EditSettings = (values, { resetForm }) => {
    const payload = {
      name: get(values, "name"),
      period_id: get(values, "period_id.value"),
      scoring_matrix_id: get(values, "scoring_matrix.value"),
      max_score: get(values, "max_score"),
      min_score: get(values, "min_score"),
      target_score: get(values, "target_score"),
      score_matrix: scoringMatrix,
      respondents: get(values, "respondents"),
      review_cycle: get(values, "review_cycle.value"),
      review_start_days: get(values, "review_start_days"),
    };
    updateReq(`${SETTINGS_URL}/${id}`, payload);
    resetForm({ values: "" });
  };

  useEffect(() => {
    if (!isAddMode) {
      setScoringMatrix(get(editData, "scores_matrix"));
      const editMatrix = matrixs
      .filter(
        (obj) =>
          get(obj, "id") === get(editData, "scoring_matrix_id")
      )
      .map((x) => {
        return { value: get(x, "id"), label: get(x, "name") };
      });
      const newEditData = {
        ...editData,
        period_id: {
          value: get(editData, "period_id"),
          label: get(editData, "period.name"),
        },
        review_cycle: {
          value: get(editData, "review_cycle"),
          label: get(editData, "review_cycle"),
        },
        scoring_matrix: {
          value: get(editMatrix,"[0]value"),
          label: get(editMatrix,"[0]label"),
        },
      };
      const fields = [
        "name",
        "max_score",
        "target_score",
        "period_id",
        "scoring_matrix",
        "min_score",
        "respondents",
        "review_cycle",
        "review_start_days",
      ];

      fields.forEach((field) =>
        formRef.current.setFieldValue(field, newEditData[field], false)
      );
      console.log(editData);
      
    }
  }, [isAddMode]);

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) toast.error(get(data, "message"));
    if (!pending && complete && !error) {
      toast.success("Settings configured successfully");
      toggleModal();
    }
  }, [createRes]);

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (error) toast.error(get(data, "message"));
    if (!pending && complete && !error) {
      toast.success("Settings Updated successfully");
      toggleModal();
    }
  }, [updateRes]);

  const nextStep = () => {
    setStep(step + 1);
  };
  const previousStep = () => {
    setStep(step - 1);
  };

  const renderForms = (values) => {
    const scoringMetrixOptions = [
      {
        value: "below_target",
        label: "Below Target",
      },
      {
        value: "above_target",
        label: "Above Target",
      },
      {
        value: "equal_target",
        label: "Equal to Target",
      },
    ];
    const AddScoreMatrix = () => {
      if (get(values, "min") && get(values, "max") && get(values, "score")) {
        const obj = {
          score: parseInt(get(values, "score")),
          min_threshold: parseInt(get(values, "min")),
          max_threshold: parseInt(get(values, "max")),
        };

        setScoringMatrix([...scoringMatrix, obj]);
      }
    };
    const deleteScoring = (index) => {
      setScoringMatrix(
        scoringMatrix.filter(
          (score, i) => scoringMatrix[i] !== scoringMatrix[index]
        )
      );
    };

    switch (step) {
      case 1:
        return (
          <Form>
            <InputSection>
              <Field
                type="text"
                name="name"
                placeholder="enter name"
                label="Name"
                component={Input}
              />
            </InputSection>
            <InputSection>
            <Field
              name="period_id"
              placeholder="select period"
              dropdownLabel="Period"
              width="96%"
              options={parseDropdown(periods)}
              isBordered={true}
              component={DropDown}
            />
            </InputSection>
             <Field
              name="scoring_matrix"
              placeholder="scoring Matrix"
              dropdownLabel="Default Scoring Matrix"
              width="90%"
              options={parseDropdown(matrixs)}
              isBordered={true}
              component={DropDown}
            />
            <Field
              type="text"
              name="min_score"
              placeholder="enter min score"
              label="Min Score"
              width="87%"
              component={Input}
            />
            <Field
              type="text"
              name="max_score"
              placeholder="enter max score"
              label="Max Score"
              width="87%"
              component={Input}
            />
            <Field
              type="text"
              name="target_score"
              placeholder="enter target score"
              label="Target Score"
              width="87%"
              component={Input}
            />
          </Form>
        );
      // case 2:
      //   return (
      //     <Form>
      //       <InputSection>
      //         <Field
      //           name="scoring_function"
      //           dropdownLabel="Scoring Function"
      //           component={DropDown}
      //           options={[{ label: "Custom", value: "Custom" }]}
      //           isBordered={true}
      //           width="97%"
      //           backgroundColor="#F5F6FB"
      //         />
      //       </InputSection>
      //       <InputSection>
      //         <ScoringSectionHeader>
      //           <TitleText>Min</TitleText>
      //           <TitleText>Max</TitleText>
      //           <TitleText>Score</TitleText>
      //           <TitleText style={{ color: "#01A8CE" }} onClick={AddScoreMatrix}>
      //             Add +
      //           </TitleText>
      //         </ScoringSectionHeader>

      //         <ScoringSection>
      //           {scoringMatrix &&
      //             scoringMatrix.map((i, index) => (
      //               <>
      //                 <TitleText>{i.min_threshold}%</TitleText>
      //                 <TitleText>{i.max_threshold}%</TitleText>
      //                 <TitleText>{i.score}</TitleText>
      //                 <span onClick={() => deleteScoring(index)}>
      //                   <CloseIcon2 />
      //                 </span>
      //               </>
      //             ))}
      //           <>
      //             <Field
      //               name="min"
      //               component={Input}
      //               width="36%"
      //               isBordered={true}
      //             />
      //             <Field
      //               name="max"
      //               component={Input}
      //               width="36%"
      //               isBordered={true}
      //             />

      //             <Field
      //               name="score"
      //               component={Input}
      //               width="36%"
      //               isBordered={true}
      //             />
      //           </>
      //         </ScoringSection>
      //       </InputSection>
      //     </Form>
      //   );
      case 2:
        return <KPIGlobalSettings />;
    }
  };
  const initialValues = {
    name: "",
    period_id: "",
    min_score: "",
    max_score: "",
    target_score: "",
    respondents: "",
    review_cycle: "",
    review_start_days: "",
  };
  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      validationSchema={GlobalSettingsSchema}
      onSubmit={isAddMode ? AddSettings : EditSettings}
    >
      {({ values }) => (
        <>
          {isModalOpen && (
            <Modal
              title={edit ? "Edit settings" : "Add new settings"}
              handleSubmit={handleSubmit}
              closeModal={toggleModal}
              noFooter
            >
              <WizzardHeader>
                <HeaderItem enabled={step === 1 ? true : false}>
                  <ScorecardIcon isActive />
                  <TitleText>Settings Parameter</TitleText>
                </HeaderItem>
                {/* <HeaderItem enabled={step === 2 ? true : false}>
                  <OrganisationTypeIcon isActive />
                  <TitleText>Scoring Matrix</TitleText>
                </HeaderItem> */}
                <HeaderItem enabled={step === 2 ? true : false}>
                  <OrganisationTypeIcon isActive />
                  <TitleText>360 Settings</TitleText>
                </HeaderItem>
              </WizzardHeader>
              {renderForms(values)}
              <Footer>
                <Button text="Cancel" backgroundColor="#fff" color="#214160" />
                <ButtonWithBorder
                  disabled={step === 1 ? true : false}
                  text="Back"
                  onClick={previousStep}
                  backgroundColor="#fff"
                  color="#214160"
                />
                {step === 2 ? (
                  <SmallButton
                    text="Finish"
                    type="submit"
                    onClick={() => handleSubmit()}
                  />
                ) : (
                  <SmallButton text="Next" onClick={nextStep} />
                )}
              </Footer>
            </Modal>
          )}
        </>
      )}
    </Formik>
  );
};

export default SettingsForm;

const ScoringContainer = styled.div`
  display: grid;
  grid-template-columns: 7fr 1fr;
`;

const ScoringSectionHeader = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 1fr;
  ${TitleText} {
    color: #c4c9fe;
  }
`;

const ScoringSection = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 1fr;
  align-items: center;
  ${TitleText} {
    font-weight: normal;
    opacity: 0.9;
  }
`;

const WizzardHeader = styled.div`
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  border: 2px solid rgba(76, 92, 251, 0.1);
  border-radius: 1em;
  margin-top: 1em;
  margin-bottom: 1em;
`;

const HeaderItem = styled.button<{ enabled: boolean }>`
  display: flex;
  font-size: 12;
  font-weight: 600;
  align-items: center;
  background-color: ${(props) => (props.enabled ? "#EBEFFF" : "#fff")};
  color: #01A8CE;
  padding: 1em 1.5em 1em 1.5em;
  border-radius: 1em;
  width: 100%;
  box-shadow: 0px 0px 0px transparent;
  border: 1px solid transparent;
  text-shadow: 0px 0px 0px transparent;
  border-color: ${(props) =>
    props.enabled ? "rgba(1,168,206,1)" : "none"};
  opacity: ${(props) => (props.enabled ? 1 : 0.4)};
  ${TitleText} {
    padding-left: 1em;
    color: #01A8CE;
    font-size: 12px;
  }
  &:focus {
    outline: none;
  }
`;

const ButtonWithBorder = styled(Button)<{ disabled: boolean }>`
  border: 2px solid #01A8CE;
  padding: 0.3em 4em;
  margin-left: auto;
  margin-right: 1em;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
`;

const SmallButton = styled(Button)`
  padding: 0.4em 4em;
  border: 2px solid #01A8CE;
`;

const Footer = styled.footer`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1em;
`;
